export default __webpack_public_path__ + "static/media/shop.145d268e.svg";